/**
 * Vietnamese translations for the application
 */
const vietnameseTranslations = {
  'Self-Test': 'Bài tự kiểm tra',
  // Common
  'Loading...': 'Đang tải...',
  'Loading data...': 'Đang tải dữ liệu...',
  'Error': 'Lỗi',
  'Cancel': 'Hủy',
  'Save': 'Lưu',
  'Update': 'Cập nhật',
  'Delete': 'Xóa',
  'Edit': 'Chỉnh sửa',
  'Actions': 'Hành động',
    'Refresh': 'Làm mới',
    'Refresh status': 'Làm mới trạng thái',
  'Search': 'Tìm kiếm',
  'Submit': 'Nộp',
  'Created': 'Ngày tạo',
  'Title': 'Tiêu đề',
  'Content': 'Nội dung',
  'Create': 'Tạo mới',
  'Confirm': 'Xác nhận',
  
  // NotesPage
  'Personal Notes': 'Ghi chú cá nhân',
  'Notes List': 'Danh sách ghi chú',
  'Add New Note': 'Thêm ghi chú mới',
  'Search notes by title or content...': 'Tìm kiếm ghi chú theo tiêu đề hoặc nội dung...',
  'Clear search': 'Xóa tìm kiếm',
  'You don\'t have any notes yet. Create your first note!': 'Bạn chưa có ghi chú nào. Hãy tạo ghi chú đầu tiên!',
  'Edit Note': 'Chỉnh sửa ghi chú',
  'Enter note title': 'Nhập tiêu đề ghi chú',
  'Enter note content': 'Nhập nội dung ghi chú',
  'Save Note': 'Lưu ghi chú',
  'Attach Document': 'Đính kèm tài liệu',
  'Supported formats: PDF, Word, Excel': 'Định dạng hỗ trợ: PDF, Word, Excel',
  'View document': 'Xem tài liệu',
  'View current document': 'Xem tài liệu hiện tại',
  'Image Preview': 'Xem hình ảnh',
  'Note Title': 'Tiêu đề ghi chú',
  'Note Content': 'Nội dung ghi chú',
  'Close': 'Đóng',
  'Document': 'Tài liệu',
  'Current Documents': 'Tài liệu hiện tại',
  'Multiple documents supported': 'Hỗ trợ nhiều tài liệu',
  'Remove document': 'Xóa tài liệu',
  
  // Confirmation Dialog
  'Confirm Delete': 'Xác nhận xóa',
  'Are you sure you want to delete this note? This action cannot be undone.': 'Bạn có chắc chắn muốn xóa ghi chú này không? Hành động này không thể hoàn tác.',
  'Delete Note': 'Xóa ghi chú',
  
  // NotesPageWithSidebar
  'Note Tools': 'Công cụ ghi chú',
  'Create New Note': 'Tạo ghi chú mới',
  'Statistics': 'Thống kê',
  'Total Notes:': 'Tổng số ghi chú:',
  
  // Pagination
  'Show': 'Hiển thị',
  'items per page': 'mục mỗi trang',
  'total items': 'tổng số mục',
  'Total entries': 'Tổng số mục',
  'First page': 'Trang đầu',
  'Previous page': 'Trang trước',
  'Next page': 'Trang sau',
  'Last page': 'Trang cuối',
  
  // Error messages
  'Cannot load notes': 'Không thể tải ghi chú',
  'Cannot create note': 'Không thể tạo ghi chú',
  'Cannot update note': 'Không thể cập nhật ghi chú',
  'Cannot delete note': 'Không thể xóa ghi chú',
  'Please enter title and content': 'Vui lòng nhập tiêu đề và nội dung',
  
  // Self-Test Page
  'Self Tests': 'Bài tự kiểm tra',
  'New': 'Mới',
  'New Test': 'Bài mới',
  'View': 'Xem',
  'Create Self-Test': 'Tạo bài tự kiểm tra',
  'Test your knowledge and get AI-powered feedback': 'Kiểm tra kiến thức và nhận phản hồi từ AI',
  'Total Tests': 'Tổng số bài',
  'Avg Score': 'Điểm TB',
  'Self-Test Submission': 'Nộp bài tự kiểm tra',
  'Use Math Editor (LaTeX)': 'Sử dụng trình soạn thảo Toán (LaTeX)',
  'Use Math Formula Editor (LaTeX)': 'Sử dụng trình nhập công thức (LaTeX)',
  'Type formulas directly': 'Gõ công thức trực tiếp',
  'You can enter formulas with full math symbols. The result will be saved as LaTeX.': 'Bạn có thể nhập công thức với đầy đủ ký hiệu toán học. Kết quả sẽ được lưu dưới dạng LaTeX.',
  'Switch on to use the math editor for equations.': 'Bật để sử dụng trình soạn thảo công thức.',
  'Type equations like x^2 + y^2 = z^2 or use the toolbar.': 'Nhập công thức như x^2 + y^2 = z^2 hoặc dùng thanh công cụ.',
  'Use the math editor to enter your full solution or final expression.': 'Sử dụng trình soạn thảo để nhập lời giải hoặc biểu thức cuối cùng.',
  'Create New Self-Test': 'Tạo bài tự kiểm tra mới',
  'Your Self-Tests': 'Bài tự kiểm tra của bạn',
  'Subject': 'Môn học',
  'Your Question': 'Câu hỏi của bạn',
  'Your Answer': 'Câu trả lời của bạn',
  'Upload Images for Question (Optional)': 'Tải lên hình ảnh cho câu hỏi (Tùy chọn)',
  'Upload Images for Answer (Optional)': 'Tải lên hình ảnh cho câu trả lời (Tùy chọn)',
  'Selected files': 'Các tệp đã chọn',
  'Remove': 'Xóa',
  'Submit Self-Test': 'Nộp bài tự kiểm tra',
  'Submitting...': 'Đang nộp...',
  'You haven\'t created any self-tests yet.': 'Bạn chưa tạo bài tự kiểm tra nào.',
  'Question': 'Câu hỏi',
  'View Details': 'Xem chi tiết',
  'Self-Test Details': 'Chi tiết bài tự kiểm tra',
  'Question Images': 'Hình ảnh câu hỏi',
  'Answer Images': 'Hình ảnh câu trả lời',
  'Feedback': 'Phản hồi',
  'Score': 'Điểm số',
  'Best Parts': 'Điểm mạnh',
  'Needs Improvement': 'Cần cải thiện',
  'Advice': 'Lời khuyên',
  'Feedback generated at': 'Phản hồi được tạo lúc',
  'Feedback is being generated. Please check back in a few moments.': 'Phản hồi đang được tạo. Vui lòng kiểm tra lại sau vài phút.',
  'Check for feedback now': 'Kiểm tra phản hồi ngay',
  'Auto-refreshing...': 'Đang tự động làm mới...',
  'Feedback is now available!': 'Phản hồi đã sẵn sàng!',
  'Failed to generate feedback. Please try submitting again.': 'Không thể tạo phản hồi. Vui lòng thử nộp lại.',
  'Download PDF': 'Tải PDF',
  'Download Feedback as PDF': 'Tải phản hồi dưới dạng PDF',
  'Mathematics': 'Toán học',
  'English': 'Tiếng Anh',
  'Literature': 'Văn học',
  'Failed to submit self-test': 'Không thể nộp bài tự kiểm tra',
  'Failed to refresh test': 'Không thể làm mới bài kiểm tra',
  'Failed to generate PDF': 'Không thể tạo tệp PDF',
  'Failed to refresh test status': 'Không thể cập nhật trạng thái bài kiểm tra',
  'Submission failed. Try again.': 'Nộp thất bại. Vui lòng thử lại.',
  'Pending': 'Đang chờ',
  'Reviewed': 'Đã đánh giá',
  'Failed': 'Thất bại',
  'Unknown': 'Không xác định',
  'Self-test submitted successfully! Feedback will be generated shortly.': 'Đã nộp bài tự kiểm tra thành công! Phản hồi sẽ được tạo trong thời gian ngắn.',
  'Please fill in both question and answer fields': 'Vui lòng điền cả câu hỏi và câu trả lời',
  'Enter your question here...': 'Nhập câu hỏi của bạn tại đây...',
  'Enter your question...': 'Nhập câu hỏi của bạn...',
  'Enter your answer here...': 'Nhập câu trả lời của bạn tại đây...',
  'Enter your answer...': 'Nhập câu trả lời của bạn...',
  'Search by subject, question, or answer...': 'Tìm kiếm theo môn học, câu hỏi hoặc câu trả lời...',
  'Refresh list': 'Làm mới danh sách',
  'No self-tests yet': 'Chưa có bài tự kiểm tra nào',
  'Create your first self-test to get AI-powered feedback on your answers': 'Tạo bài tự kiểm tra đầu tiên để nhận phản hồi từ AI cho câu trả lời của bạn',
  'Create your first self-test to get started': 'Tạo bài tự kiểm tra đầu tiên để bắt đầu',
  'View details': 'Xem chi tiết',
  'Check for feedback': 'Kiểm tra phản hồi',
  'Select Subject': 'Chọn môn học',
  'Submit your question and answer for AI feedback': 'Gửi câu hỏi và câu trả lời để nhận phản hồi từ AI',
  'Click a symbol to insert it': 'Nhấn vào ký hiệu để chèn',
  'Type LaTeX here, e.g., x^2 + y^2 = z^2': 'Nhập LaTeX tại đây, ví dụ: x^2 + y^2 = z^2',
  'Use the symbols above or type LaTeX directly': 'Sử dụng các ký hiệu ở trên hoặc nhập LaTeX trực tiếp',
  'Formula Preview': 'Xem trước công thức',
  'Type your solution in LaTeX here...': 'Nhập lời giải bằng LaTeX tại đây...',
  'Submit for Review': 'Gửi để đánh giá',
  'Feedback is being generated...': 'Phản hồi đang được tạo...',
  'Failed to generate feedback. Please retry later.': 'Không thể tạo phản hồi. Vui lòng thử lại sau.',
  'Deleted.': 'Đã xóa.',
  'Could not delete.': 'Không thể xóa.',
  'Error refreshing item.': 'Lỗi khi làm mới mục.',
  'Submitted! Feedback will be ready soon.': 'Đã gửi! Phản hồi sẽ sẵn sàng trong thời gian ngắn.',
  'You must be logged in to access this page': 'Bạn phải đăng nhập để truy cập trang này',
  'Are you sure you want to delete this item? This cannot be undone.': 'Bạn có chắc muốn xóa mục này không? Hành động này không thể hoàn tác.',
  'Are you sure you want to delete this self-test? This action cannot be undone.': 'Bạn có chắc chắn muốn xóa bài tự kiểm tra này không? Hành động này không thể hoàn tác.',
  'Delete Self-Test': 'Xóa bài tự kiểm tra',
  'Failed to delete self-test': 'Không thể xóa bài tự kiểm tra',
  'Self-test deleted successfully': 'Đã xóa bài tự kiểm tra thành công',
  'This feedback was generated using our rule-based system due to AI service rate limits. Try again later for AI-powered feedback.': 'Phản hồi này được tạo bằng hệ thống dựa trên quy tắc do giới hạn tần suất của dịch vụ AI. Vui lòng thử lại sau để nhận phản hồi từ AI.',
  'Feedback was generated using rule-based method because the AI service quota has been exceeded. AI-powered feedback will be available when the quota is renewed.': 'Phản hồi này được tạo bằng hệ thống dựa trên quy tắc vì hạn ngạch dịch vụ AI đã bị vượt quá. Phản hồi từ AI sẽ khả dụng khi hạn ngạch được gia hạn.',
  'Processing feedback... please wait a few minutes': 'Đang xử lý phản hồi... vui lòng đợi vài phút',
  'Failed to fetch self-tests': 'Không thể tải danh sách bài tự kiểm tra',
  
  // Table common (used in Self-Test Page)
  'Status': 'Trạng thái',
  'Created At': 'Ngày tạo'
};

export default vietnameseTranslations;